import BlockedUsersList from '../components/BlockedUsersList';

export default function BlockedUsersPage() {
  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Blocked Users</h1>
      <BlockedUsersList />
    </div>
  );
}
